jQuery(function($) {
  var preAjax = window.a9sf823fb;

  var emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  var btnContinue = $('.btn--continue');
  var popupForm = $('#popup-form');
  var popupMessage = $('#popup-message');

  function submitNewsletter() {
    // event.preventDefault();
    var popupID = $(this).attr('data-popup');
    var thisBtnFieldID = $(this).attr('data-input');
    var thisBtnField = $(thisBtnFieldID);
    var thisBtnValue = thisBtnField.val();
    var popupForm = $('#popup-form');
    var popupMessage = $('#popup-message');

    if (thisBtnValue === '' || !emailRegex.test(thisBtnValue)) {
      thisBtnField.addClass('has-error').focus();
      return false;
    } else {
      var continueURL = $(this).attr('data-continue') +'?email=' + thisBtnValue;
      // alert(continueURL);
      thisBtnField.removeClass('has-error');
      $(this).addClass('is-loading');
      $(this).attr('disabled', 'disabled');
      btnContinue.attr('href', continueURL);
      $.ajax({
          url: preAjax['sdc-xu23rf'], // Global access to the WordPress ajax handler file
          type: 'POST',
          dataType: 'html',
          data: {
            action: 'subscribe_user', // Your custom hook/action name
            security: preAjax['ak9au+82ns'], // A nonce value
            email: thisBtnValue, // The thisBtnValue you want to send
            lang: window.LANG,
          },
      }).done(function(data){
        console.log('done: ', data)
        if(popupID) {
          openPopUp(popupID);
        } else {
          popupForm.hide();
          popupMessage.fadeIn();
        }

        $(this).addClass('is-success');
      }).fail(function(data){
        console.log('ERROR: ', data);
        $(this).removeAttr('disabled')
      }).always(function(){
        $(this).removeClass('is-loading')
        // hideLoading( $searchResults );
        // submittingSearch = false;
      });
    }
  }

  $('.js-newsletter-btn').on('click', submitNewsletter);
});



// WEBPACK FOOTER //
// ./scripts/newsletter.js